import type { ServiceItem } from '@/cms/fields/types/checkout-page'
import React from 'react'
import { BusService } from '@/scopes/checkout/components/services/BusService'
import { SweaterService, TShirtService } from '@/scopes/checkout/components/services/ClothingService'
import { GenericService } from '@/scopes/checkout/components/services/GenericService/GenericService'
import { MealplanDPService } from '@/scopes/checkout/components/services/MealplanDPService'
import { CancellationInsuranceService } from './CancellationInsuranceService/CancellationInsuranceService'
import { TravelInsuranceService } from './TravelInsuranceService'

const serviceMapper = {
  'BUS': BusService,
  'TSHIRT*': TShirtService,
  'SWEATER*': SweaterService,
  'ACCOMMODATION': MealplanDPService,
  'TRAVEL*': TravelInsuranceService,
  'CANCEL*': CancellationInsuranceService,
}

export function getGenericServiceComponent(aName: string, item: ServiceItem, type: string, index: number) {
  const key = `${type}-${aName}-${index}`

  for (const [pattern, Component] of Object.entries(serviceMapper)) {
    const isMatch = pattern.endsWith('*') ? (aName.startsWith(pattern.replace(/\*/g, '')) || aName === pattern) : aName === pattern
    if (!isMatch)
      continue

    return <Component item={item} key={key} />
  }
  return <GenericService item={item} key={key} />
}
